import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Grid, Stack} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Breadcrumbs,
  Typography,
  InputBase,
  Divider,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {Link, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState, setAuthData} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {selectUiState, setUiData} from "../../../store/uiSlice";
import {AGENT_CLIENTS} from "../../../constants/apiConstant";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {removeCookies} from "../../../constants/helper";
import debounce from "lodash/debounce";
import NoDataComponent from "../../no-data";
import Register from "../../register";

const rows = Array.from({length: 9}, (_, index) => ({
  id: index + 1,
  customername: "John Doe",
  // policyNumber: "PROP10292024-1540",
  contact: "9876543210",
  email: "a@aaa.com",
  company: "Task source",
  // TOL: "Shipping",
  // details: "Received",
}));

const ClientRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const isFirstRender = useRef(true);
  const {user} = useSelector(selectAuthState);
  const {clientList, clientCount, clientsParentProposal} =
    useSelector(selectDataStoreState);
  const {showLoader} = useSelector(selectUiState);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);

  const clients = useMemo(
    () => (clientList?.length ? clientList : []),
    [clientList]
  );
  const currentRowData = useMemo(() => currentRow, [currentRow]);
  // console.log("clients", clientList);

  const [openEndorseForm, setClaimForm] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const fetchClients = useCallback(async () => {
    if (page === null || rowsPerPage === null) {
      return;
    }
    dispatch(setUiData({showLoader: true}));

    let data = {
      agent_id: user?.id,
      limit: rowsPerPage,
      offset: page * rowsPerPage,
    };

    const options = {
      method: AGENT_CLIENTS.method,
      headers: AGENT_CLIENTS.headers,
      body: JSON.stringify(data),
    };
    // dispatch(setUiData({ showLoader: false }));
    // return;
    try {
      const response = await fetch(AGENT_CLIENTS.url, options);
      const res = await response.json();
      if (res.status == 1) {
        dispatch(
          setDataStore({
            clientList: res?.user_list || [],
            clientCount: res?.total_count || 0,
          })
        );
      } else {
        console.error("Error fetching clients");
      }
      dispatch(setUiData({showLoader: false}));
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      dispatch(setUiData({showLoader: false}));
      navigate("/");
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false; // Prevent the second fetch caused by Strict Mode
    //   return;
    // }
    fetchClients();
  }, [fetchClients]);
  const [values, setValues] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && inputValue.trim()) {
      setValues([...values, inputValue.trim()]);
      setInputValue("");
      event.preventDefault();
    }
  };

  const handleDelete = (chipToDelete) => {
    setValues(values.filter((value) => value !== chipToDelete));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const clientSearch = async (searchTerm) => {
    if (page === null || rowsPerPage === null) return;

    dispatch(setUiData({showLoader: true}));

    const data = {
      agent_id: user?.id,
      limit: rowsPerPage,
      offset: page * rowsPerPage,
      search: searchTerm,
    };

    const options = {
      method: AGENT_CLIENTS.method,
      headers: AGENT_CLIENTS.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(AGENT_CLIENTS.url, options);
      const res = await response.json();

      dispatch(setUiData({showLoader: false}));

      if (res.status == 1) {
        return res?.user_list ?? [];
      } else {
        GlobalNotificationPopup({type: "error", message: res?.message});
        return [];
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      console.error("Error:", error);
      dispatch(setUiData({showLoader: false}));
      navigate("/");
      return [];
    }
  };

  const loadOptions = async (inputValue) => {
    const normalizedInput = inputValue.toLowerCase();
    const clients = await clientSearch(normalizedInput);
    dispatch(
      setDataStore({
        clientList: clients || [],
        clientCount: clients?.length || 0,
      })
    );
    // return clients.map((client) => ({
    //     ...client,
    //     label: (
    //         <>
    //             {client.first_name} {client.last_name} <br />
    //             <small>{client?.email}</small>
    //         </>
    //     ),
    //     value: client.user_id,
    // }));
  };

  const debouncedLoadOptions = debounce(loadOptions, 500);

  const handleSelect = (clientSelected) => {
    dispatch(
      setDataStore({
        proposalStep: 1,
        proposal_id: null,
        previous_proposal_id: null,
        editingSubmitted: false,
        clickedSteps: [],
      })
    );
    dispatch(setAuthData({selectedClient: clientSelected}));
    navigate("/new-proposal");
  };

  const handleClientDetails = (row) => {
    // console.log("A", row);

    // return

    navigate("/details/client/" + row.user_id);
  };

  const columns = [
    {id: "id", label: "#", minWidth: 25},
    {
      id: "full_name",
      label: "Client Name",
      minWidth: 160,

      renderCell: (item) => (
        <div>
          <Link to={"/details/client/" + item.user_id} style={{color: "#000"}}>
            {item.full_name}
          </Link>
        </div>
      ),
    },
    // { id: "policyNumber", label: "Policy Number", minWidth: 160 },
    {id: "mobile_no", label: "Contact Number", minWidth: 110},
    {id: "email", label: "Email", minWidth: 110},
    {id: "company", label: "Company", minWidth: 160},
    // { id: "TOL", label: "Type of Loss", minWidth: 100 },
    {
      id: "Action",
      label: "Action",
      minWidth: 150,

      renderCell: (item) => (
        <Button
          //onClick={() => handleClientDetails(item)}
          // disabled
          // className={style.IssuedPolicyBtnSucces}
          variant="contained"
          style={{background: "#004F71"}}
          onClick={() => {
            handleSelect(item);
          }}
        >
          New Proposal
        </Button>
      ),
    },
  ];

  return (
    <>
      <Grid
        container
        spacing={3}
        className="customeContainer"
        justifyContent="center"
      >
        <Grid size={{xs: 12, lg: 12}} sx={{mt: 2, mb: 2}}>
          <div className={style.propPagination}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" to="/dashboard">
                Dashboard
              </Link>
              <Link underline="hover" color="inherit" to="/clients">
                Clients
              </Link>

              <Typography sx={{color: "text.primary"}}>
                Client Registration
              </Typography>
            </Breadcrumbs>
          </div>
        </Grid>
      </Grid>

      <section className={style.ProposalUnderProgessSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}}>
            <div className={style.client_search_main}>
              <div className={style.c_Page_title}>
                <h3> Client Registration </h3>
              </div>

              {/* <Stack direction="row" spacing={2} alignItems="center">
                <Paper
                  component="form"
                  sx={{ p: "2px 4px", display: "flex", alignItems: "center" }}
                  className={style.clientSearch}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search Client"
                    inputProps={{ "aria-label": "client search box" }}
                    onChange={(e) => debouncedLoadOptions(e.target.value)}
                  />
                  <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                    <SearchIcon />
                  </IconButton>

                </Paper>
                <Box className={style.addClientBtn}>
                  <Button variant="contained"> Add Client </Button>
                </Box>
              </Stack> */}
            </div>

            {/* <Paper className={style.propTableMain}> */}
            <Register />
            {/* </Paper> */}
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default ClientRegister;
